export { default } from './dist/vue-page-transition.common'
export * from './dist/vue-page-transition.common'
import './dist/vue-page-transition.css'
